// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-module--wrapper--21qA0"};